import { Component } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ErrorDialogData } from "./error-dialog-data";
import { DialogBase } from "../dialog-base";

@Component({
    standalone: false,
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent extends DialogBase<ErrorDialogComponent, ErrorDialogData> {
}
